var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_699_899)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5887 105.537L109.538 12.5885C117.543 4.58314 130.626 4.58314 138.631 12.5885L231.58 105.537C239.586 113.543 239.586 126.626 231.58 134.631L138.631 227.58C130.626 235.585 117.543 235.585 109.538 227.58L16.5887 134.631C8.58306 126.626 8.58306 113.543 16.5887 105.537Z",
    fill: "#4D4D4D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.714 13.3703L17.3705 107.714C10.5384 114.546 10.5384 125.622 17.3705 132.454L111.714 226.798C118.546 233.63 129.623 233.63 136.455 226.798L230.798 132.454C237.63 125.622 237.63 114.546 230.798 107.714L136.455 13.3703C129.623 6.5383 118.546 6.5383 111.714 13.3703Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2634 109.972L113.972 50.2634C119.538 44.6967 128.631 44.6967 134.197 50.2634L193.905 109.972C199.472 115.538 199.472 124.631 193.905 130.197L134.197 189.905C128.631 195.472 119.538 195.472 113.972 189.905L54.2634 130.197C48.6967 124.631 48.6967 115.538 54.2634 109.972Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.828 50.979L54.9786 111.828C50.5722 116.234 50.5722 123.379 54.9786 127.785L115.828 188.634C120.234 193.041 127.378 193.041 131.785 188.634L192.634 127.785C197.04 123.379 197.04 116.234 192.634 111.828L131.785 50.979C127.378 46.5725 120.234 46.5725 115.828 50.979Z",
    fill: "#70B002"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_699_899",
    x: 0.584473,
    y: 0.584473,
    width: 247,
    height: 247,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_699_899"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_699_899",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircle);
export default __webpack_public_path__ + "static/media/success_circle.24dcbf5b8a26b3497a554e9be955f038.svg";
export { ForwardRef as ReactComponent };